module.exports = __webpack_public_path__ + "static/media/Pansky_kopec.3e8a1ef6.md";